import UnauthorizedErrorPlaceholderSvg from '@/../img/placeholders/unauthorized-error-placeholder.svg';
import React from 'react';
import { BackgroundWithLogo } from './common/background-with-logo';
import { GenericErrorPlaceholder } from './generic-error-placeholder';

const ErrorMessageHeaderText = () => (
  <>
    <span css="white-space: nowrap">Looks like you do not have permission</span>
    <br />
    <span css="white-space: nowrap">to view the requested data.</span>
  </>
);

const ErrorMessageSubtext = () => (
  <>
    <span>
      If you believe you are seeing this page in error, please contact your
      local representative.
    </span>
  </>
);

export function UnauthorizedErrorPlaceholder() {
  return (
    <BackgroundWithLogo>
      <GenericErrorPlaceholder
        renderErrorMessageHeaderText={<ErrorMessageHeaderText />}
        renderErrorMessageSubtext={<ErrorMessageSubtext />}
        renderErrorImage={
          <UnauthorizedErrorPlaceholderSvg height={805} width={680} />
        }
      />
    </BackgroundWithLogo>
  );
}
